module.exports = require("unist-util-parents");


//////////////////
// WEBPACK FOOTER
// external "unist-util-parents"
// module id = 40
// module chunks = 0 1 2 3 4 5 6 7 8 9 12 13